import {
  CoverageDLossOfUseValue,
  CoverageEarthquakeValue,
  CoverageInflationGuardValue,
  CoverageWaterDamageValue,
} from "@covertree/new-business-graphql";

export function mapPercentEnumToDisplayValue(
  enumValue?:
    | CoverageDLossOfUseValue
    | CoverageEarthquakeValue
    | CoverageInflationGuardValue
    | CoverageWaterDamageValue
    | null
): string {
  switch (enumValue) {
    case CoverageInflationGuardValue.Percent3:
      return "3%";
    case CoverageDLossOfUseValue.Percent10:
    case CoverageEarthquakeValue.Percent10:
    case CoverageWaterDamageValue.Percent10:
      return "10%";
    case CoverageEarthquakeValue.Percent15:
      return "15%";
    case CoverageDLossOfUseValue.Percent20:
    case CoverageEarthquakeValue.Percent20:
      return "20%";
    case CoverageWaterDamageValue.Percent25:
      return "25%";
    case CoverageDLossOfUseValue.Percent30:
      return "30%";
    case CoverageDLossOfUseValue.Percent40:
      return "40%";
    case CoverageWaterDamageValue.Percent50:
      return "50%";
    case CoverageWaterDamageValue.FullCoverage:
      return "Full Coverage";
    default:
      return "Unknown";
  }
}
